import React from 'react';
import { DatesProvider, DatePickerInput } from '@mantine/dates';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import dayjs from 'dayjs';
import 'dayjs/locale/et.js';
import 'dayjs/locale/lt.js';
import 'dayjs/locale/lv.js';
import 'dayjs/locale/ru.js';
import 'dayjs/locale/en.js';
import i18n from '../../i18n';

interface ColumbusDatePickerInputProps {
    name?: string;
    value: Date | null;
    onChange: (date: Date | null) => void;
    placeholder?: string;
    minDate?: Date;
    maxDate?: Date;
    valueFormat?: string; // default "DD.MM.YYYY"
    className?: string;
}

const ColumbusDatePickerInput: React.FC<ColumbusDatePickerInputProps> = ({
    name,
    value,
    onChange,
    placeholder = '-',
    minDate,
    maxDate,
    valueFormat = 'DD.MM.YYYY',
    className = ''
}) => {
    return (
        <div className={`columbus-date-picker-input ${className}`}>
            <DatesProvider settings={{ locale: i18n.language || 'en' }}>
                <DatePickerInput
                    name={name}
                    style={{ maxWidth: '150px' }}
                    placeholder={placeholder}
                    minDate={minDate}
                    maxDate={maxDate}
                    value={value}
                    valueFormat={valueFormat}
                    rightSection={<FontAwesomeIcon icon={faCalendarDays} style={{ marginRight: '.5rem' }} />}
                    popoverProps={{ 
                        zIndex: 10000,
                        withinPortal: true,
                        trapFocus: true,
                        returnFocus: true
                    }}
                    classNames={{ input: 'visual-selection-aid' }}
                    onChange={(val: string | null) => {
                        if (val) {
                            const date = dayjs(val, valueFormat).toDate();
                            onChange(date);
                        } else {
                            onChange(null);
                        }
                    }}
                />
            </DatesProvider>
        </div>
    );
};

export default ColumbusDatePickerInput;